var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 15990",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 202",
    d: "M0 0h46v46H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31536",
    d: "M12 12h24v24H12z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31537",
    d: "M31.43 24.98a7.793 7.793 0 00.07-.98 7.793 7.793 0 00-.07-.98l2.11-1.65a.5.5 0 00.12-.64l-2-3.46a.5.5 0 00-.44-.25.467.467 0 00-.17.03l-2.49 1a7.306 7.306 0 00-1.69-.98l-.38-2.65A.488.488 0 0026 14h-4a.488.488 0 00-.49.42l-.38 2.65a7.683 7.683 0 00-1.69.98l-2.49-1a.566.566 0 00-.18-.03.5.5 0 00-.43.25l-2 3.46a.493.493 0 00.12.64l2.11 1.65a7.931 7.931 0 00-.07.98 7.931 7.931 0 00.07.98l-2.11 1.65a.5.5 0 00-.12.64l2 3.46a.5.5 0 00.44.25.467.467 0 00.17-.03l2.49-1a7.306 7.306 0 001.69.98l.38 2.65A.488.488 0 0022 34h4a.488.488 0 00.49-.42l.38-2.65a7.683 7.683 0 001.69-.98l2.49 1a.566.566 0 00.18.03.5.5 0 00.43-.25l2-3.46a.5.5 0 00-.12-.64zm-1.98-1.71a5.343 5.343 0 01.05.73c0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68a5.857 5.857 0 01-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43a5.674 5.674 0 01-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68a5.857 5.857 0 011.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43a5.674 5.674 0 011.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM24 20a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2.006 2.006 0 01-2 2z",
    fill: "#fff"
  })));
}

export default SvgSettingsIcon;